import { useEffect, useState } from 'react';
import { getSnapshot, type SnapshotResponse } from '../api';

export interface UseSnapshotResult {
  snapshot: SnapshotResponse | null;
  error: string | null;
  loading: boolean;
}

export function useSnapshot(intervalMs = 10_000): UseSnapshotResult {
  const [snapshot, setSnapshot] = useState<SnapshotResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const s = await getSnapshot();
        if (!cancelled) {
          setSnapshot(s);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) setError((e as Error).message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    tick();
    const id = setInterval(tick, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs]);

  return { snapshot, error, loading };
}
